import {CanActivateFn} from '@angular/router';
import {inject} from '@angular/core';
import {UserAclService} from '../../services/infrastructure/auth/acl/user-acl/user-acl.service';
import {GuardService} from '../guard/guard.service';

export const adminGuard: CanActivateFn = () => {
  const guardService = inject(GuardService);
  const userAclService = inject(UserAclService);

  const hasPermissions = userAclService.isLibraryAdmin() || userAclService.isApplicationAdmin();
  if (hasPermissions) {
    return true;
  }
  return guardService.createRedirectUrlTree();
};
